import { style } from "@vanilla-extract/css";

// The vertical padding matches the sparkline presets' `padding: { top: 8, bottom: 8 }`.
export const wrapper = style({
  boxSizing: "border-box",
  width: "100%",
  height: "100%",
  padding: "8px 4px"
});

// The marker's positioning box: the plot itself, without the padding.
export const plot = style({
  position: "relative",
  width: "100%",
  height: "100%"
});

export const canvas = style({
  display: "block",
  width: "100%",
  height: "100%",
  // A non-scaling stroke at the extremes would otherwise lose half its width.
  overflow: "visible"
});

export const baseline = style({ stroke: "currentColor" });

export const marker = style({
  position: "absolute",
  width: 6,
  height: 6,
  borderRadius: "50%",
  transform: "translate(-50%, -50%)",
  // The plot under it keeps tracking the pointer.
  pointerEvents: "none"
});
